export default `uniform vec3 color;

void main() {
    vec2 xy = gl_PointCoord.xy - vec2(0.5);
    float lineWidth = 0.1; 

    
    float distX = abs(xy.x); 
    float distY = abs(xy.y); 

    
    float alphaX = 1.0 - step(lineWidth, distX);
    float alphaY = 1.0 - step(lineWidth, distY);

    
    float alpha = max(alphaX, alphaY);

    gl_FragColor = vec4(color, alpha);
}`